//kkcode for synchronous call
const asyncLocalStorage = {
  setItem: function (key, value) {
    return Promise.resolve().then(function () {
      localStorage.setItem(key, value);
    });
  },
  getItem: function (key) {
    return Promise.resolve().then(function () {
      return localStorage.getItem(key);
    });
  },
};

if ($(".complexion-element").length) {
  let e = null;

  function sortByProduct(e, o) {
    return e.name > o.name ? 1 : o.name > e.name ? -1 : 0;
  }

  function displayShadeSelector(o) {
    $("html").animate({ scrollTop: 0 }, "slow");
    if (o == "ivory") {
      localStorage.setItem("Main", 1);
    }
    if (o == "honey") {
      localStorage.setItem("Main", 2);
    }
    if (o == "caramel") {
      localStorage.setItem("Main", 3);
    }
    if (o == "cinnamon") {
      localStorage.setItem("Main", 4);
    }
    if (o == "mocha") {
      localStorage.setItem("Main", 5);
    }
    if (o == "ebony") {
      localStorage.setItem("Main", 6);
    }

    $("#shade-finder-wrapper").hide(),
      $(".shade-selector-shades-container").removeClass("active");
    const t = document.getElementById("shade-selector-shades");
    t.innerHTML = "";
    const s = complexionsData.complexions[o].shades;
    a = Object.keys(s).map((e) => {
      return {
        name: e,
        short_desc: s[e].short_desc,
        image: s[e].image,
        image_hover: s[e].image_hover,
        product: s[e].product,
        brands: s[e].brands,
      };
    });
    a.sort(sortByProduct),
      Object.keys(a).forEach(function (s) {
        const n = document.createElement("h3");
        (n.innerHTML = o), (n.className = "uppercase");
        const i = document.createElement("p");
        (i.innerHTML = a[s].name), (i.className = "uppercase");
        const j = document.createElement("span");
        (j.innerHTML = a[s].short_desc), (j.className = "short-desc");
        const c = document.createElement("div");
        (c.className = "shade-info"),
          c.appendChild(n),
          c.appendChild(i),
          c.appendChild(j);
        const l = document.createElement("div");
        (l.className = "shade-image"),
          (l.style.backgroundImage = `url('${a[s].image}')`);
        const r = document.createElement("div");
        if (
          ((r.className = "shade-content"),
          r.appendChild(l),
          r.appendChild(c),
          a[s].image_hover)
        ) {
          const e = document.createElement("div");
          (e.className = "shade-image-hover"),
            (e.style.backgroundImage = `url('${a[s].image_hover}')`),
            r.appendChild(e);
        }
        const d = document.createElement("div");
        (d.className = "shade-item"),
          d.appendChild(r),
          $(document).ready(function () {
            d.onclick = function () {
              if ("undefined" == typeof customerId)
                window.location.href.indexOf("foundation") > -1
                  ? (console.log(o, "foundation"),
                    "ivory" == o &&
                      window.location.replace(
                        "https://www.thelipbar.com/products/1-00-go-off-fast-face"
                      ),
                    "honey" == o &&
                      (window.location =
                        "https://www.thelipbar.com/products/2-00-stay-ready-fast-face"),
                    "caramel" == o &&
                      (window.location =
                        "https://www.thelipbar.com/products/3-00-boss-moves-fast-face"),
                    "cinnamon" == o &&
                      (window.location =
                        "https://www.thelipbar.com/products/4-00-stuntin-fast-face"),
                    "mocha" == o &&
                      (window.location =
                        "https://www.thelipbar.com/products/5-00-vogue-fast-face"),
                    "ebony" == o &&
                      (window.location =
                        "https://www.thelipbar.com/products/6-00-squad-goals-fast-face"))
                  : ($("#shade-selector").hide(),
                    $("#customer-login-screen").show());
              else if (window.location.href.indexOf("foundation") > -1)
                console.log(o, "foundation"),
                  "ivory" == o &&
                    window.location.replace(
                      "https://www.thelipbar.com/products/1-00-go-off-fast-face"
                    ),
                  "honey" == o &&
                    (window.location =
                      "https://www.thelipbar.com/products/2-00-stay-ready-fast-face"),
                  "caramel" == o &&
                    (window.location =
                      "https://www.thelipbar.com/products/3-00-boss-moves-fast-face"),
                  "cinnamon" == o &&
                    (window.location =
                      "https://www.thelipbar.com/products/4-00-stuntin-fast-face"),
                  "mocha" == o &&
                    (window.location =
                      "https://www.thelipbar.com/products/5-00-vogue-fast-face"),
                  "ebony" == o &&
                    (window.location =
                      "https://www.thelipbar.com/products/6-00-squad-goals-fast-face");
              else {
                $("#shade-selector").hide();
              }

              e = o;
            };
          }),
          t.appendChild(d);
      }),
      setTimeout(function () {
        $(".shade-selector-shades-container").addClass("active");
        $(document).ready(function () {
          $("#shade-selector-shades").on("init", function (e, o) {
            $(".shade-selector-shades-container").addClass("active");
          });
        });
      }),
      $("#shade-selector").show();
  }
}

$(".closest-complexion").click(function () {
  var complexion = $(this).data("id");
  $("#closestComplexion").val(complexion);
});

$(".lipstick-preference").click(function () {
  var preference = $(this).data("id");
  $("#lipstickPreference").val(preference);
});

$(".complexion-element").click(function (event) {
  $(".back-to").show();

  let complexion = $("#closestComplexion").val();
  if (complexion === "") {
    alert("Please Choose Your Complexion..!!");
  } else {
    $(".lipstick-preference").click(function () {
      var preference = $("#lipstickPreference").val();
      localStorage.setItem("preference", preference);
      var PRPLips = localStorage.getItem("preference");
      var PRPURL ="https://quiz.prpwebs.com/index.php?foundation=" + localStorage.getItem("shade") + "&lips=" + PRPLips;
      fetch(PRPURL)
        .then((resp) => resp.json())
        .then(function (data) {
          //set localstorage value
          asyncLocalStorage
            .setItem("PRPResultData", JSON.stringify(data))
            .then(function () {
              return asyncLocalStorage.getItem("PRPResultData");
            })
            .then(function (value) {
              setVariableValues(value);
            });
        })
        .catch(function (error) {
          console.log(error);
        });

      KlaviyoSubscribe.attachToForms("#email_signup", {
        hide_form_on_success: true,
        extra_properties: {
          $source: "New Complexion Quiz",
          Shaderange: localStorage.getItem("Main"),
          TintedShade: localStorage.getItem("TintedShade"),
        },
      });
    });
  }

  $(".lipstick-preference").click(function () {
    $("#shade-finder-wrapper").hide();
    $("#quiz-screen").hide();
    $("#email-screen").show();
  });

  $(".klaviyo_submit_button").click(function () {
    setTimeout(function () {
      $("#result-screen").fadeIn("fast");
      $("#email-screen").fadeOut("fast");
    }, 2000);
  });

  $(".guest-btn").click(function () {
    $("#email-screen").hide();
    $("#result-screen").show();
    jQuery(".result-screen").show();
  });
});

function setVariableValues(PRPResultData) {
  const prpResult = JSON.parse(PRPResultData);
  photoOne = prpResult.banner[0];
  title = prpResult.banner[1];
  shade2 = prpResult.banner[2];
  if (title == "Ebony") {
    title2 = "";
  } else {
    title2 = title;
  }
  shade = localStorage.getItem("shade");
  beforeAfter = prpResult.banner[3];
  let preference = localStorage.getItem("preference");
  let bannerImage =  document.querySelector('.shadeBanner');
  bannerImage.src = prpResult.banner[0];
  getProductsInfo(prpResult.fastfacekit, prpResult.fast_face_kit_variant, "face");                      
  getProductsInfo(prpResult.just_a_tint, prpResult.just_a_tint_variant, "face");           
  getProductsInfo(prpResult.tintedkit, prpResult.tinted_kit_variant, "face");           
  getProductsInfo(prpResult.concealer, prpResult.concealer_variant, "face");   
  getProductsInfo(prpResult.powder, prpResult.powder_variant, "face");       
  getProductsInfo(prpResult.palette, prpResult.palette_variant, "face");
  getProductsInfo(prpResult.fresh_glow, prpResult.fresh_glow_variant, "face");           
  getProductsInfo(prpResult.blush, prpResult.blush_variant, "face");           
  if (preference == "nude") {
    getProductsInfo(prpResult.lips[0], prpResult.nude_variant[0], "lips");
    getProductsInfo(prpResult.lips[1], prpResult.nude_variant[1], "lips");
    getProductsInfo(prpResult.lips[2], prpResult.nude_variant[2], "lips");
    getProductsInfo(prpResult.lips[3], prpResult.nude_variant[3], "lips");
  } else if (preference == "bold") {
    getProductsInfo(prpResult.lips[0], prpResult.bold_variant[0], "lips");
    getProductsInfo(prpResult.lips[1], prpResult.bold_variant[1], "lips");
    getProductsInfo(prpResult.lips[2], prpResult.bold_variant[2], "lips");
    getProductsInfo(prpResult.lips[3], prpResult.bold_variant[3], "lips");
  } else if (preference == "bright") {
    getProductsInfo(prpResult.lips[0], prpResult.bright_variant[0], "lips");
    getProductsInfo(prpResult.lips[1], prpResult.bright_variant[1], "lips");
    getProductsInfo(prpResult.lips[2], prpResult.bright_variant[2], "lips");
    getProductsInfo(prpResult.lips[3], prpResult.bright_variant[3], "lips");

  }	
}
             		
function getProductsInfo(product_handle, product_variant, productDisplayArea){
  try {
  let variant_title = "";
  let variant_img = "";	
  let variant_hover_img = "";
  let variant_id = "";
  let variant_price = "";
  let product_title = "";
  let variant_available ="";
  let variant_compare_at_price ="";
  let productData = all_Products_data[product_handle];
  let productVariants = productData.variants;
  let key = productVariants.find(key => key.id == Number(product_variant));
  variant_id = key.id;
  product_handle = productData.handle ;
  variant_price = Shopify.formatMoney(key.price);
  variant_price = variant_price.replace(".00", "");
  if(key.compare_at_price !== null){
  variant_compare_at_price = Shopify.formatMoney(key.compare_at_price);
  variant_compare_at_price = variant_compare_at_price.replace(".00", "");
  }
  
  if(key.public_title !== null && productData.type != 'Bundle'){
    product_title = productData.title;
    variant_title = key.public_title ;
  } 
  else if(productData.type == 'Bundle'){
  	variant_title = productData.title ;
  }
 
  if(key.featured_image !== null){
    variant_img = key.featured_image.src ;
  }
  else if(key.featured_image == null){
    variant_img = productData.featured_image ;
  }
  if(productData.type == 'Bundle'){
    variant_available = `<div class="single-variants-atc-btn pw-btn shop_now_button">
                   <a href="/products/${product_handle}?variant=${variant_id}">
                       <span class="selected_shade_price">${variant_price} <small><del>${variant_compare_at_price} </del></small> </span>
                       <span class="selected_shade_btn_name">Shop Now</span>
                   </a>
                 </div>`;
  }
  else if(key.available){
    variant_available = `<form method="post" action="/cart/add">
                <input type="hidden" name="id" value="${variant_id}" />
                <div class="single-variants-atc-btn swatch--${product_handle} pw-btn">
                  <span class="selected_shade_price sale">
                    ${variant_price}
                    <small><del>${variant_compare_at_price} </del></small>
                  </span>
                  <span class="selected_shade_btn_name atc-btn-text">Add To Cart</span>
                </div>
              </form>`;
  }
  else{
    variant_available = `<form method="post" action="/cart/add">
                <input type="hidden" name="id" value="${variant_id}" />
                <div class="single-variants-atc-btn swatch--${product_handle} pw-btn">
                  <span class="selected_shade_price sale">
                    ${variant_price}
                    <small><del>${variant_compare_at_price} </del></small>
                  </span>
                  <span class="selected_shade_btn_name atc-btn-text soldOut">Sold Out</span>
                </div>
              </form>`;
  }
  
  
  let productMedia = productData.media ;
  let key2 = productMedia.filter(function (data) {
    console.log(data);
    if(productData.type == 'Bundle'){
      return data.alt === key.option1;
    }
    else{
    return data.alt === variant_title;
    }
  }).map(function (data, index) {
    if(index == 1){
      return variant_hover_img = data.src;
    }
    var index = index + 1;
  })
  let menu ="";
  if(productDisplayArea == 'face'){
 	 menu = document.querySelector('#result-screen .faceProductSeries');
  }
  else if(productDisplayArea == 'lips'){
  	 menu = document.querySelector('#result-screen .lipsProductSeries');
  }
 
    if(productData.title == "Easy Beauty Bundle"){
     	 variant_hover_img = variant_img;
    }
    
  const productUrl = `/products/${product_handle}?variant=${variant_id}`;
  const cardMediaHtml =
    typeof window.buildCardProductSliderMediaHtml === 'function'
      ? window.buildCardProductSliderMediaHtml({
          mainSrc: variant_img,
          hoverSrc: variant_hover_img,
          alt: variant_title,
          productUrl: productUrl,
          hoverEnabled: true,
        })
      : `<div class="card__media product__imgs_updates" style="position:relative;cursor:pointer;" onclick="location.href='${productUrl}';">
          <div class="card-product-slider card-product-slider--hover-enabled media media--transparent media--hover-effect">
            <img src="${variant_img}" alt="${variant_title}" loading="lazy" class="motion-reduce main_product_img" width="900" height="900" />
            <img src="${variant_hover_img}" loading="lazy" class="motion-reduce main_product_hover_img" width="900" height="900" />
          </div>
        </div>`;

  let pairWithHtml = '';
  pairWithHtml += `<div class="card-wrapper underline-links-hover">
  <div class="card-boxs card card--standard card--media" style="--ratio-percent: 100%">
    <a href="${productUrl}"> </a>
    <div class="card__inner color-background-1 ratio" style="--ratio-percent: 100%">
      ${cardMediaHtml}
      <div class="card__content">
        <a href="/products/${product_handle}?variant=${variant_id}"> </a>
        <div class="card__information swatch- swatch-variant">
          <a href="/products/${product_handle}?variant=${variant_id}"> </a>
          <h3 class="card__heading">
            <a href="/products/${product_handle}?variant=${variant_id}"> </a><a
              href="/products/${product_handle}?variant=${variant_id}" class="full-unstyled-link gt_america_bold">
              ${variant_title}
            </a>
            <a href="/products/${product_handle}?variant=${variant_id}" class="full-unstyled-link gt_america">
              ${product_title}
            </a>
          </h3>
           <!-- Stamped - Begin Star Rating Badge -->
                  <span 
                  class="stamped-product-reviews-badge stamped-main-badge" 
                  data-id="{{ product.id }}" 
                  data-product-sku="${product_handle }" 
                  data-product-title="${product_title}" 
                  data-product-type="{product.type}" 
                  style="display: block;">
                  {product.metafields.stamped.badge}
                  </span>
                  <!-- Stamped - End Star Rating Badge -->
			<div class="yotpo bottomLine" data-product-id="${productData.id}"></div>
          <div class="add_to_cart mobile">
            <div class="swatches_box gt_america">
              <div class="add-to-cart-button">
                    ${variant_available}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card__content">
      <div class="card__information swatch-false swatch-variant">
        <h3 class="card__heading h5">
          <a href="/products/${product_handle}?variant=${variant_id}"
            class="full-unstyled-link gt_america_bold">
            ${product_title}
          </a>
          <a href="/products/${product_handle}?variant=${variant_id}"
            class="full-unstyled-link gt_america">
            ${variant_title}
          </a>
        </h3>
     <!-- Stamped - Begin Star Rating Badge -->
<span 
class="stamped-product-reviews-badge" 
data-id="${ productData.id }"
data-product-sku="${ product_handle }" 
data-product-type="${productData.type}" 
data-product-title="${product_title}" 
style="display:block;">
</span>
<!-- Stamped - End Star Rating Badge -->
<div class="yotpo bottomLine" data-product-id="${productData.id}"></div>
        <div class="card-information"></div>
        <div class="add_to_cart desktop">
          <div class="swatches_box gt_america">
            <div class="add-to-cart-button">
            
                  ${variant_available}
                
            </div>
          </div>
        </div>
      </div>
      <div class="card__badge bottom left">
        <span class="badge badge--bottom-left color-#D10000">Sale</span>
      </div>
    </div>
  </div>
</div>
`;
  const menuItem = createMenuItem(pairWithHtml);
  menu.appendChild(menuItem);
  if (typeof window.initCardProductSliders === 'function') {
    window.initCardProductSliders(menuItem);
  }
  const faceLoader = document.querySelector(".faceProductSeries .loading");
  const lipsLoader = document.querySelector(".lipsProductSeries .loading");  
  faceLoader.remove();
  lipsLoader.remove();
    
    
// TO get Yotpo Star
    setTimeout(function(){
             // yotpo.refreshWidgets();
      StampedFn.reloadUGC();  
             console.log('yotpo refreshed');
           },2000);  
    
}
catch(err) {
//   console.error(`Oops Something went wrong while rendering ${product_handle} with variant ${product_variant}`)
  console.error(err.message);
}
}
function createMenuItem(name) {
    let li = document.createElement('div');
    li.innerHTML = name;
    return li;
}
 
